export function lastMarkdownPartIndex(parts) {
  let last = -1
  for (let index = 0; index < parts.length; index += 1) {
    if (parts[index]?.type === 'markdown') last = index
  }
  return last
}
